export enum DocumentRelatedEntityType {
  Project = 1,
  Investor = 2,
  Initiative = 3,
  InvestorIntelItem = 4,
  InvestorEsgReports = 5,
  Client = 6,
}
